<template>
    <div v-if="!block.isHiddenAll" class="review-block">
<!--        <h5 class="name">{{block.displayName}}</h5>-->
        <review-component-renderer v-for="comp in components" :component="comp" :key="`${block.id}-${comp.id}`"/>

        <div class="children">
            <review-block v-for="child in block.children" :block="child" :key="`${block.id}-${child.id}`"/>
        </div>
    </div>
</template>

<script>
import ReviewComponentRenderer from "@components/review/review-component-renderer.vue";

export default {
    name: `review-block`,
    components: {ReviewComponentRenderer},
    props: {
        block: { type: Object, required: true }
    },
    computed: {
        components() {
            return this.block.getComponents();
        }
    }
}
</script>

<style lang="scss">
//.children {
//    padding-left: 20px;
//}
</style>
